import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import "./index.css";
import Layout from "./root/components/layout/Layout";
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";
import ContentIndex from "./viewer/index/components/ContentIndex";
import VideoPage from "./viewer/videoPlayer/components/VideoPage";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./root/RootReducer";
import rootSaga from "./root/RootSaga";
import PresentersIndex from "./presenters/components/index/PresentersIndex";
import PresenterProfile from "./presenters/components/profile/PresenterProfile";
import HomePage from "./viewer/index/components/HomePage";
import ProjectIndex from "./viewer/index/components/project/ProjectIndex";
import ProgramIndex from "./viewer/index/components/program/ProgramIndex";
import { AnimateSharedLayout } from "framer-motion";
import Login from "./auth/Login";
import { msalConfig } from "./auth/AuthConfig";
import { AuthenticatedTemplate, UnauthenticatedTemplate, MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import ScrollToTop from "./common/components/scroll/ScrollToTop";
import TimelineTop from "./studio/components/timelineTop/TimelineTop";
import SlideViewer from "./viewer/videoPlayer/components/SlideViewer";
import CreatedVideo from "./studio/components/createdVideo/CreatedVideo";
import TemplateIndex from "./studio/components/template/TemplateIndex";
import DirectoryIndex from "./studio/components/directory/DirectoryIndex";
import EditTimeline from "./studio/components/editTimeline/EditTimeline";
import LoginUnavailable from "./viewer/index/components/loginUnavailable/LoginUnavailable";
import Error from "./root/components/layout/Error";
import SessionTimeout from "./viewer/index/components/loginUnavailable/SessionTimeout";
import "./i18n";
// import * as serviceWorker from "./serviceWorker";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: rootReducer,
    middleware: [sagaMiddleware],
});

sagaMiddleware.run(rootSaga);

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <AnimateSharedLayout>
                <HashRouter>
                    <Provider store={store}>
                        <UnauthenticatedTemplate>
                            <Route path="/" component={Login} />
                        </UnauthenticatedTemplate>
                        <AuthenticatedTemplate>
                            <Layout>
                                <ScrollToTop />
                                <Switch>
                                    <Route
                                        exact
                                        path="/loginUnavailable"
                                        component={LoginUnavailable}
                                    />
                                    <Route
                                        exact
                                        path="/sessionTimeout"
                                        component={SessionTimeout}
                                    />
                                    <Route exact path="/homepage" component={HomePage} />
                                    <Route exact path="/project" component={ProjectIndex} />
                                    <Route exact path="/channel" component={ProgramIndex} />
                                    <Route exact path="/videos" component={ContentIndex} />
                                    <Route exact path="/slides" component={ContentIndex} />
                                    <Route exact path="/video/:id" component={VideoPage} />
                                    <Route exact path="/slidestock/:id" component={SlideViewer} />
                                    <Route exact path="/presenters" component={PresentersIndex} />
                                    <Route
                                        exact
                                        path="/studio/timelineTop"
                                        component={TimelineTop}
                                    />
                                    <Route
                                        exact
                                        path="/studio/editTimeline/:id"
                                        component={EditTimeline}
                                    />
                                    <Route
                                        exact
                                        path="/studio/createdVideo"
                                        component={CreatedVideo}
                                    />
                                    <Route
                                        exact
                                        path="/presenters/:id"
                                        component={PresenterProfile}
                                    />
                                    <Route exact path="/studio/homepage" component={TimelineTop} />
                                    <Route
                                        exact
                                        path="/studio/directory"
                                        component={DirectoryIndex}
                                    />
                                    <Route
                                        exact
                                        path="/studio/template"
                                        component={TemplateIndex}
                                    />

                                    <Redirect exact from="/" to="/homepage" />
                                    <Route component={Error} />
                                </Switch>
                            </Layout>
                        </AuthenticatedTemplate>
                    </Provider>
                </HashRouter>
            </AnimateSharedLayout>
        </MsalProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// serviceWorker.register();
